<script>
import { mapGetters } from 'vuex'
import Announcement   from './Announcement.vue'

// Container for announcements. Mounted absolutely on top.

export default {
  name: 'Announcements',
  components: { Announcement },
  computed: {
    ...mapGetters( 'announcements', [ 'most_recent' ]),
  },
}
</script>

<template>
  <div
    :id="$id()"
    aria-label="Announcements from The Hmm"
  >
    <transition name="fall-in" >
      <Announcement
        v-if="most_recent"
        :announcement="most_recent"
      />
    </transition>
  </div>
</template>

<style scoped>
#announcements {
  position   : fixed;
  /* top        : var(--marquee-height); */
  top: 0;
  right: calc( 1 * var(--side-width) + 2rem);
  height     : var(--header-height);
  width      : 0;
  overflow   : visible;
  font-size  : var(--size-m);
  transform  : translateY( calc( var(--header-height) * -3 ) );
  animation  : enter var(--enter) ease var(--slow) forwards !important;
  transition : all 0.5s ease;
  z-index    : 4;
  opacity    : 0;
}
.mobile #announcements {
  right: calc( 1 * var(--side-width));
}
.fall-in-move,
.fall-in-enter-active,
.fall-in-leave-active {
  transition : all 0.5s ease;
}
.fall-in-enter-from,
.fall-in-leave-to {
  transform  : translateY( calc( var(--header-height) * -3 ) );
}
.fall-in-leave-active {
  position   : absolute;
}
@keyframes enter {
  from {
    transform: translateY( calc( var(--header-height) * -3 ) );
    opacity: 0;
  }
  to   {
    transform: translateY( 0 );
    opacity: 1;
  }
}
</style>
